import { authnClient } from '@frontend/auth';
import { isWeaveTokenBufferActive } from '@frontend/auth-helpers';

export async function authQuickCheck() {
  const ignoreHosts = [
    // preview links use legacy auth
    'preview.weavelab.xyz',
    'f.weavedev.net',
    'edge.getweave.com',
  ];

  // these are all the public routes, scraped from routeTree.gen.ts
  // TODO find a more scalable way to do this
  const ignoreRoutes = [
    '/front-channel-logout',
    '/hydra-error',
    '/insurance-eligibility-report',
    '/it-partner-quotes',
    '/login',
    '/okta-redirect',
    '/onboarding-demo',
    '/password-reset',
    '/reset',
    '/sign-in',
    '/nr-public-test',
    '/portal/login',
    '/quotes',
    '/reset-password',
    '/sign-in/callback',
    '/it-partner-quotes',
    '/porting/loa',
    '/quotes',
    '/test',
    '/accept-invite',
    '/porting',
    '/user-invite',
    '/portal/accept-invite',
    '/portal/user-invite',
  ];

  if (
    ignoreHosts.some((host) => location.hostname.includes(host)) ||
    ignoreRoutes.some((route) => location.pathname.includes(route))
  ) {
    return;
  }

  const isUserAuthenticated = authnClient.isUserAuthenticated() || isWeaveTokenBufferActive();
  if (!isUserAuthenticated) {
    await authnClient.signIn({ meta: { source: 'auth_check' } }); // this will trigger the sign-in flow and top-level page navigation
  }
}
